import { Component, OnInit, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { IRequest } from "./company-dialog.model";
import { CompanyDialogService } from "./company-dialog.service";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { TextValidatorService } from "src/app/core/validators/text-validator.service";
import { MessageConstants } from "src/app/core/constants/message";
import { IItemDropdown } from "src/app/core/interfaces/dropdown.models";
import { Table } from "primeng/table";

@Component({ standalone: false,
    selector: 'app-company-dialog',
    templateUrl: './company-dialog.component.html',

    styleUrls: ['./company-dialog.component.css']
})
export class CompanyDialogComponent implements OnInit {

    @ViewChild('table') table: Table;

    currentPage: number = 1;

    isFirstLoad: boolean = true;
    totalRows: number = 0;
    lsData: IRequest[] = [];
    codigosMessage: any;
    mensajesMessage: any;

    loaded: boolean = true;

    onKeyDownLettersAndNumbers = (event: any) => this.textValidatorService.validateOnlyLettersAndNumbers(event);

    constructor(private service: CompanyDialogService
        , public ref: DynamicDialogRef
        , public config: DynamicDialogConfig
        , private readonly textValidatorService: TextValidatorService
        , private cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        let dataReq: IRequest = {
            Ruc: "",
            RazonSocial: "",
            GetAll: false
        };
        this.getData(dataReq, false);
    }

    getData(request: IRequest, pagination: boolean) {
        this.loaded = false;
        [this.codigosMessage, this.mensajesMessage] = MessageConstants;
        this.service.getPaginated(request)
            .subscribe(
                {
                    next: (data) => {
                        let dataTmp = data;
                        if (dataTmp) {
                            this.lsData = dataTmp;
                            if (pagination) {
                                setTimeout(() => { this.navigateToPage(this.currentPage); });
                            }
                        }
                        setTimeout(() => { this.cdr?.detectChanges(); });
                    },
                    error: (error) => {
                        if (error) {
                            console.log(error);
                        }
                        this.loaded = true;
                        this.lsData = [];
                        setTimeout(() => { this.cdr?.detectChanges(); });
                    },
                    complete: () => {
                        this.loaded = true;
                        setTimeout(() => { this.cdr?.detectChanges(); });
                    }
                }
            );
    }

    navigateToPage(pageNumber: number) {
        const desiredPageIndex = pageNumber * this.table.rows;
        const first = desiredPageIndex - this.table.rows;

        if (this.table.totalRecords == first) {
            this.table.first = first - this.table.rows;
        } else {
            this.table.first = first;
        }
    }


    onRowDblClick(event: any, dataSelected: any) {
        if (dataSelected) {
            let _description = ((dataSelected.razon_social) ? dataSelected.razon_social : "");
            let itemDropdown: IItemDropdown = {
                code: dataSelected.id,
                description: _description,
                dataSerialize: JSON.stringify(dataSelected)
            }
            this.ref.close(itemDropdown);
        }

    }

}
